import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";

export const listLeverage = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listLeverage", "leverages");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.LEVERAGE.LEVERAGE_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
};

const formListJson = (formPayload, listPayload) => {
    const { data = {}, meta = {} } = formPayload;
    const { leverages = [], meta: listMeta = {} } = listPayload;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = leverages.map(leverage => {
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case 'enabled': {
                    value = leverage[field.id] ? 'Enabled' : 'Disabled'
                    break;
                }
                default: value = leverage[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}